import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", key: "lang.en" },
  { code: "pl", key: "lang.pl" },
  { code: "es", key: "lang.es" },
  { code: "fr", key: "lang.fr" },
];

export default function LanguageSwitcher({ light = false }: { light?: boolean }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const currentCode = (i18n.language || "en").split("-")[0];
  const current = languages.find((l) => l.code === currentCode) ?? languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
          light
            ? "text-white hover:bg-white/20"
            : "text-foreground-950 hover:bg-background-200"
        }`}
      >
        <i className="ri-global-line w-4 h-4 flex items-center justify-center text-base" />
        <span>{t(current.key)}</span>
        <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-base transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 shadow-sm">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2 text-left text-sm transition-colors cursor-pointer ${
                l.code === currentCode
                  ? "bg-primary-100 text-primary-800 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span>{t(l.key)}</span>
              {l.code === currentCode && (
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-base" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}